// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__xBr1y","section":"Button_section__ZD8JV"};